import React from "react";
import { useEffect } from "react";
import { confirmAlert } from "react-confirm-alert";
import { isWebView, Userlogin } from "../Component/Utils/general-function";

let reminderTime = 15 * 24 * 60 * 60 * 1000;
export const useNotificationPermisionReminder = () => {
  useEffect(() => {
    try {
      if (isWebView() || !Userlogin()) return; // only remide android notification permission if not allow
      let lastPromptTime = localStorage.getItem("last_permision_reminder");
      let now = new Date().getTime();
      if (!lastPromptTime || now - Number(lastPromptTime) > reminderTime) {
        let permission = Notification.permission;
        if (permission === "denied") {
          confirmAlert({
            customUI: ({ onClose }) => {
              window.addEventListener("popstate", onClose);
              return (
                <div className="popup-overlay px-3 py-3 text-center">
                  <h6>🔔 Stay Updated!</h6>
                  <p>Get instant alerts when new leads arrive.</p>
                  <small className="d-block">
                    Go to: Settings → Apps → Carthi Dealer → Notifications →
                    Enable
                  </small>
                  <button
                    className="submitbtn mt-2 popup-btn"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Ok
                  </button>
                </div>
              );
            },
          });

          localStorage.setItem("last_permision_reminder", now);
        }
      }
    } catch (error) {}
  }, []);
};
